import { instance } from "../handlerAPI";
import apiBasic from "../apiBasic";

//wocwo,login,header,navbar api

//-----------API---------------------------------------------------------------
//call api 時都加上 try catch && async await
//以call_為開頭

export const run90sample = (data) => {
  return instance.post(
    `${apiBasic.conn}://${apiBasic.url}/api/run90sample`,
    data
  );
};

export const modifyRun90pass = (data) => {
  return instance.post(
    `${apiBasic.conn}://${apiBasic.url}/api/modifyRun90pass`,
    data
  );
};

export const modifyRun91pass = (data) => {
  return instance.post(
    `${apiBasic.conn}://${apiBasic.url}/api/modifyRun91pass`,
    data
  );
};

export const getAllRun92 = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllRun92`, {
    params: _params,
  });
};

export const addRun92 = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/addRun92`, data);
};

export const getAllRun91 = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllRun91`, {
    params: _params,
  });
};

export const chooseWpcDocuments = (_params) => {
  return instance.get(
    `${apiBasic.conn}://${apiBasic.url}/api/chooseWpcDocuments`,
    { params: _params }
  );
};

export const getAllRunb = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllRunb`);
};

export const getAllRun90 = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllRun90`, {
    params: _params,
  });
};

export const getSingleWpc = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getSingleWpc`, {
    params: _params,
  });
};

export const login = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/login`, data);
};

export const getWsWl = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getWsWl`);
};

export const getAps = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAps`, {
    params: _params,
  });
};

export const apsWoN = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/apsWoN`, data);
};

export const getPNs = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getPNs`);
};

export const manualWoN = (data) => {
  return instance.post(
    `${apiBasic.conn}://${apiBasic.url}/api/manualWoN`,
    data
  );
};

export const getAllWpc = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllWpc`, {
    params: _params,
  });
};

export const chooseWpcMold = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/chooseWpcMold`, {
    params: _params,
  });
};

export const chooseWpcStaff = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/chooseWpcStaff`, {
    params: _params,
  });
};

export const upStaff = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/upStaff`, data);
};

export const getAllStaffs = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllStaffs`);
};

export const prefix = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/prefix`, data);
};

export const getWpc = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getWpc`, {
    params: _params,
  });
};

export const getMoldInfo = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getMoldInfo`, {
    params: _params,
  });
};

export const chooseWpcMoldInfo = (_params) => {
  return instance.get(
    `${apiBasic.conn}://${apiBasic.url}/api/chooseWpcMoldInfo`,
    {
      params: _params,
    }
  );
};

export const wpc = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/wpc`, data);
};

export const prepare = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/prepare`, data);
};

export const open = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/open`, data);
};

export const pause = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/pause`, data);
};

export const resume = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/resume`, data);
};

export const close = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/close`, data);
};

export const downStaff = (data) => {
  return instance.post(
    `${apiBasic.conn}://${apiBasic.url}/api/downStaff`,
    data
  );
};

export const suffix = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/suffix`, data);
};

export const downLine = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/downLine`, data);
};

export const initPage = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/initPage`);
};

export const getAllRtnWpc = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllRtnWpc`);
};

export const returnWpcApi = (data) => {
  return instance.post(
    `${apiBasic.conn}://${apiBasic.url}/api/returnWpc`,
    data
  );
};

export const timeline = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/timeline`, {
    params: _params,
  });
};

export const getPauseList = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getPauseList`);
};

export const getDirList = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getDirList`);
};

export const getAbnList = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAbnList`);
};

export const report = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/report`, data);
};

export const getAllAbn = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllAbn`, {
    params: _params,
  });
};

export const sip = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/sip`);
};

export const sop = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/sop`, {
    params: _params,
  });
};

export const getAllMultiWpc = () => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getAllmultiWpc`);
};

export const resolve = (data) => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/resolve`, data);
};

export const uploadMultiWpc = (data) => {
  return instance.post(
    `${apiBasic.conn}://${apiBasic.url}/api/uploadMultiWpc`,
    data
  );
};

export const getMulti = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getMulti`, {
    params: _params,
  });
};

export const logout = () => {
  return instance.post(`${apiBasic.conn}://${apiBasic.url}/api/logout`);
};
